import { render, staticRenderFns } from "./UsersFormEdit.vue?vue&type=template&id=64f3a160&lang=pug"
import script from "./UsersFormEdit.vue?vue&type=script&lang=js"
export * from "./UsersFormEdit.vue?vue&type=script&lang=js"
import style0 from "./UsersFormEdit.vue?vue&type=style&index=0&id=64f3a160&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports